import React from 'react';
import { PDFIcon } from '../../../../components/Icon/Icon';

const Body = () => (
    <>
        <h1>
            <a href="/corporate-governance">Our Committees</a>
            <span>/</span>
            <a href="/corporate-governance/our-policies" className="selected">
                Our Policies
            </a>
        </h1>
        <h2>Our Policies</h2>
        <ul className="column">
            <li>
                <a
                    href="https://files.jdplc.com/pdf/whistleblowing-policy.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <PDFIcon name="our-policies/whistleblowing.png" />
                    Whistleblowing
                    <br />
                    Policy
                </a>
            </li>
            <li>
                <a
                    href="https://files.jdplc.com/pdf/anti-corruption-and-bribery-policy.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <PDFIcon name="our-policies/anti-corruption.png" />
                    Anti-Corruption and
                    <br />
                    Bribery Policy
                </a>
            </li>
        </ul>
    </>
);

export const content = {
    image: 'https://files.jdplc.com/images/about/our-policies.jpg',
    body: Body,
};
